import { useState } from 'react';

import { useEventOptions } from './hooks';
import { ClientDataType } from '../types';
import { useVisualComponentsContext } from '../contexts/visualComponents';
import { useTranslation } from '../hooks/useTranslation';
import { useQueryStateContext } from '../contexts';

type EventSelectProps = {
  value: ClientDataType | null;
  onChange: (value: ClientDataType | null) => void;
  isInvalid?: boolean;
  isInRequirement?: boolean;
};

export const EventSelect = ({
  onChange,
  value,
  isInvalid = false,
  isInRequirement = false,
}: EventSelectProps) => {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const { EventSelect: VisualComponent } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const { options } = useEventOptions({ search });

  return (
    <VisualComponent
      isInRequirement={isInRequirement}
      onChange={onChange}
      value={value}
      hasError={isInvalid}
      isDisabled={isReadOnly}
      placeholder={t('v2.requirementBuilder.eventSelectPlaceholder')}
      options={options}
      search={search}
      setSearch={setSearch}
      isVirtualized
    />
  );
};
